import S from 'string';

class TextFormatter {

    static parseAddress(address, city, state, zip) {
        const addressArray = address.split(", ");
        switch (addressArray.length) {
            case 3:
                return { street1: addressArray[0], street2: null, city: addressArray[1], stateZip: addressArray[2] };
            case 4:
                return { street1: addressArray[0], street2: addressArray[1], city: addressArray[2], stateZip: addressArray[3] };
            case 5:
                return { street1: addressArray[0], street2: null, city: addressArray[1], stateZip: addressArray[2] };
            case 6:
                return { street1: addressArray[0], street2: addressArray[1], city: addressArray[2], stateZip: addressArray[3] };
            default:
                return { street1: address, street2: null, city: city, stateZip: `${state} ${zip}` };
        }
    }

    static cleanPhoneNumber(phoneNumber) {
        if (!phoneNumber) {
            return null;
        }

        const standardNo = phoneNumber.replace(/[^\d]/g, '');
        if (standardNo.length !== 10) {
            return phoneNumber;
        }

        if (phoneNumber === 'N/A') {
            return null;
        }

        if (standardNo === '0000000000') {
            return null;
        }

        return standardNo;

    }

    static formatPhoneNumber(s) {
        const s2 = ("" + s).replace(/\D/g, '');
        const m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!m)
            ? null
            : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }

    static generateMapLink(street, city, stateZip) {
        //const link = `http://maps.google.com/?q=${street},${city},${stateZip}`;
        const appleLink = `https://maps.apple.com/?address=${street},${city},${stateZip}`;
        return appleLink;
    }

    static humanizeTitle(str) {
        str = S(str)
            .humanize()
            .titleCase()
            .s;

        return str;
    }

    static titleCase(sperator, ...args) {

        const results = [];

        args.forEach((arg) => {
            if (arg) {
                results.push(S(arg.toLowerCase()).titleCase().s);
            }

        });

        return results.join(sperator);
    }

    static formatMacAddress(macAddress) {
        if (!macAddress) {
            return null;
        }

        //handle test modems
        if (macAddress.includes('SQC')) {
            return macAddress;
        }

        macAddress = macAddress
            .trim()
            .replace(/:/g, '');

        macAddress = macAddress
            .replace(/(..)/g, '$1:')
            .slice(0, -1);

        return macAddress.toUpperCase();
    }
}

export default TextFormatter;


// WEBPACK FOOTER //
// ./src/utils/TextFormatter.js